import { gql, useQuery } from "@apollo/client";

export function useGetPolicyNudgeHistory(page: number, policyId?: string, nudgeId?: string) {
  return useQuery(
    gql`
    query getPolicyNudgeHistory($page: Int!, $policyId: MongoID, $nudgeId: MongoID) {
      company_policy_nudge_history(page: $page, policyId: $policyId, nudgeId: $nudgeId) {
        _id
        log_item_name
        action_type
        policy_id
        policy_nudge_id
        changes {
          field_name
          value
        }
        created_at
        created_by_user {
          name
        }
      }
    }
    `,
    {
      variables: {
        page,
        policyId: policyId || undefined,
        nudgeId: nudgeId || undefined
      },
      fetchPolicy : 'network-only'
    }
  );
}
